import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { authAPI } from '../services/api';

export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        const hash = location.hash.substring(1);
        const params = new URLSearchParams(hash);
        const sessionId = params.get('session_id');

        if (!sessionId) {
          navigate('/login');
          return;
        }

        const response = await authAPI.createSession(sessionId);
        navigate('/home', { state: { user: response.data }, replace: true });
      } catch (error) {
        console.error('Erro no callback de autenticação:', error);
        navigate('/login', { replace: true });
      }
    };

    processSession();
  }, [location.hash, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-blue-600 border-r-transparent"></div>
        <p className="mt-4 text-slate-600">Autenticando...</p>
      </div>
    </div>
  );
};

export default AuthCallback;